// phonics_data_rr.js
// Song/Chant 来源: F:\BaiduNetdiskDownload\Phonics\Rr.mp4 (用户指定，时间段 00:10~01:34)
// Story 1/2/3 来源: F:\17talkxyz\Phonics_AtoZ\Letter Rr\Rr1/Rr2/Rr3.mp4 (完整)

const MEDIA_BASE = '/media/phonics/rr';

const letterDataRr = {
  letter: 'Rr',
  coverBg: `${MEDIA_BASE}/image1.jpeg`,
  coverPoster: `${MEDIA_BASE}/Rr.png`,

  songVideo: {
    src: `${MEDIA_BASE}/Rr.mp4`,
    poster: `${MEDIA_BASE}/Rr.png`,
    startTime: 10,
    endTime: 94,
  },

  wordVideos: [
    { src: `${MEDIA_BASE}/video_s3_word1.mp4`, poster: `${MEDIA_BASE}/image8.png`, word: 'rat', wordCn: '老鼠' },
    { src: `${MEDIA_BASE}/video_s3_word2.mp4`, poster: `${MEDIA_BASE}/image9.png`, word: 'rose', wordCn: '玫瑰花' },
    { src: `${MEDIA_BASE}/video_s3_word3.mp4`, poster: `${MEDIA_BASE}/image10.png`, word: 'red', wordCn: '红色的' },
    { src: `${MEDIA_BASE}/video_s3_word4.mp4`, poster: `${MEDIA_BASE}/image11.png`, word: 'room', wordCn: '房间' },
  ],

  storySections: [
    {
      label: 'Learn the Story (1)',
      layout: 'video-left-vocab-right',
      videos: [
        { src: `${MEDIA_BASE}/video_story_ring.mp4`, poster: `${MEDIA_BASE}/image13.png` },
      ],
      splitAt: 3,
      lines: [
        {
          en: 'ring',
          cn: '电话铃响',
          audioEn: `${MEDIA_BASE}/w_en_ring.mp3`,
          audioCn: `${MEDIA_BASE}/w_cn_ring.mp3`,
        },
        {
          en: 'flower',
          cn: '花',
          audioEn: `${MEDIA_BASE}/w_en_flower.mp3`,
          audioCn: `${MEDIA_BASE}/w_cn_flower.mp3`,
        },
        {
          en: 'What do you like?',
          cn: '你喜欢什么？',
          audioEn: `${MEDIA_BASE}/w_en_what_do_you_like.mp3`,
          audioCn: `${MEDIA_BASE}/w_cn_what_do_you_like.mp3`,
        },
        {
          en: 'Ring! Ring! Ring!',
          cn: '电话铃响！',
          audioEn: `${MEDIA_BASE}/story1_en_1.mp3`,
          audioCn: `${MEDIA_BASE}/story1_cn_1.mp3`,
        },
        {
          en: 'Rat! Rat! What flower do you like?',
          cn: '鼠鼠！鼠鼠！你喜欢什么花？',
          audioEn: `${MEDIA_BASE}/story1_en_2.mp3`,
          audioCn: `${MEDIA_BASE}/story1_cn_2.mp3`,
        },
        {
          en: 'Roses! Roses! I like roses.',
          cn: '玫瑰！玫瑰！我喜欢玫瑰。',
          audioEn: `${MEDIA_BASE}/story1_en_3.mp3`,
          audioCn: `${MEDIA_BASE}/story1_cn_3.mp3`,
        },
      ],
    },
    {
      label: 'Learn the Story (2)',
      layout: 'video-top-lines-bottom',
      videos: [
        { src: `${MEDIA_BASE}/video_story_color.mp4`, poster: `${MEDIA_BASE}/image14.png` },
      ],
      lines: [
        {
          en: 'Rat! Rat! What color do you like?',
          cn: '鼠鼠！鼠鼠！你喜欢什么颜色？',
          audioEn: `${MEDIA_BASE}/story2_en_1.mp3`,
          audioCn: `${MEDIA_BASE}/story2_cn_1.mp3`,
        },
        {
          en: 'Red! Red! I like red.',
          cn: '红！红！我喜欢红色。',
          audioEn: `${MEDIA_BASE}/story2_en_2.mp3`,
          audioCn: `${MEDIA_BASE}/story2_cn_2.mp3`,
        },
      ],
    },
    {
      label: 'Learn the Story (3)',
      layout: 'video-left-vocab-right',
      videos: [
        { src: `${MEDIA_BASE}/video_story_room.mp4`, poster: `${MEDIA_BASE}/image15.png` },
      ],
      splitAt: 1,
      lines: [
        {
          en: 'come',
          cn: '来',
          audioEn: `${MEDIA_BASE}/w_en_come.mp3`,
          audioCn: `${MEDIA_BASE}/w_cn_come.mp3`,
        },
        {
          en: 'Come to my room!',
          cn: '来我的房间！',
          audioEn: `${MEDIA_BASE}/story3_en_1.mp3`,
          audioCn: `${MEDIA_BASE}/story3_cn_1.mp3`,
        },
        {
          en: 'Happy birthday!',
          cn: '生日快乐！',
          audioEn: `${MEDIA_BASE}/story3_en_2.mp3`,
          audioCn: `${MEDIA_BASE}/story3_cn_2.mp3`,
        },
      ],
    },
  ],
};

export default letterDataRr;
